import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import t from 'format-message';
import { outcomeResultShape, scoringMethodShape, scoringTierShape, contextShape, stylesShape } from "../../store/shapes.js";
import ScoringTiers from "./ScoringTiers/index.js";
import MasteryCounts from "./MasteryCounts/index.js";
import MasteryDescription from "./MasteryDescription/index.js";
import { sanitizeHtml } from "../../lib/sanitize.js";
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { contextConfiguredWithProficiencies, getScoringMethodFromContext, getScoringTiersFromContext } from "../../util/proficienciesUtils.js";
var OutcomeView = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomeView, _React$Component);
  var _super = _createSuper(OutcomeView);
  function OutcomeView() {
    _classCallCheck(this, OutcomeView);
    return _super.apply(this, arguments);
  }
  _createClass(OutcomeView, [{
    key: "getScoringMethod",
    value: function getScoringMethod() {
      var _this$props = this.props,
        scoringMethod = _this$props.scoringMethod,
        context = _this$props.context;
      return contextConfiguredWithProficiencies(context) ? getScoringMethodFromContext(context) : scoringMethod;
    }
  }, {
    key: "getScoringTiers",
    value: function getScoringTiers() {
      var _this$props2 = this.props,
        scoringTiers = _this$props2.scoringTiers,
        context = _this$props2.context;
      if ((scoringTiers === null || scoringTiers === void 0 ? void 0 : scoringTiers.length) > 0) {
        return scoringTiers;
      }
      return contextConfiguredWithProficiencies(context) ? getScoringTiersFromContext(context) : null;
    }
  }, {
    key: "getDisplayMasteryInformation",
    value: function getDisplayMasteryInformation() {
      var _this$props3 = this.props,
        context = _this$props3.context,
        outcomeResult = _this$props3.outcomeResult;
      return !(contextConfiguredWithProficiencies(context) && !outcomeResult);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        description = _this$props4.description,
        outcomeResult = _this$props4.outcomeResult,
        title = _this$props4.title,
        artifactTypeName = _this$props4.artifactTypeName,
        displayMasteryDescription = _this$props4.displayMasteryDescription,
        displayMasteryPercentText = _this$props4.displayMasteryPercentText,
        friendlyDescription = _this$props4.friendlyDescription,
        features = _this$props4.features;
      var scoringMethod = this.getScoringMethod();
      var scoringTiers = this.getScoringTiers();
      var displayMasteryInformation = this.getDisplayMasteryInformation();
      var displayMasteryCounts = scoringMethod && outcomeResult && displayMasteryInformation;
      return jsx("div", null, jsx("div", {
        css: this.props.styles.title,
        "data-automation": "outcomeView__title"
      }, jsx(Text, {
        size: "x-large",
        transform: "uppercase"
      }, title)), displayMasteryCounts && jsx(MasteryCounts, {
        outcomeResult: outcomeResult,
        scoringMethod: scoringMethod
      }), friendlyDescription && jsx(React.Fragment, null, jsx(View, {
        as: "div",
        margin: "".concat(displayMasteryCounts ? 'medium' : 'x-small', " small 0 0"),
        padding: "small small x-small small",
        background: "secondary",
        "data-automation": "outcomeView__friendly_description_header"
      }, jsx(Text, {
        weight: "bold"
      }, t('Friendly Description'))), jsx(View, {
        as: "div",
        margin: "0 small 0 0",
        padding: "0 small small small",
        background: "secondary",
        "data-automation": "outcomeView__friendly_description_expanded"
      }, jsx(Text, null, friendlyDescription))), jsx("div", {
        css: this.props.styles.description,
        "data-automation": "outcomeView__description"
      }, jsx(Text, {
        size: "medium",
        wrap: "break-word"
      }, jsx("div", {
        dangerouslySetInnerHTML: {
          // eslint-disable-line react/no-danger
          __html: sanitizeHtml(description)
        }
      }))), scoringTiers && scoringMethod && jsx(ScoringTiers, {
        outcomeResult: outcomeResult,
        scoringTiers: scoringTiers,
        scoringMethod: scoringMethod
      }), displayMasteryDescription && displayMasteryInformation && jsx(MasteryDescription, {
        artifactTypeName: artifactTypeName,
        displayMasteryPercentText: displayMasteryPercentText,
        scoringMethod: scoringMethod,
        features: features
      }));
    }
  }]);
  OutcomeView.displayName = "OutcomeView";
  return OutcomeView;
}(React.Component), _class2.propTypes = {
  context: contextShape,
  description: PropTypes.string.isRequired,
  friendlyDescription: PropTypes.string,
  outcomeResult: outcomeResultShape,
  title: PropTypes.string.isRequired,
  scoringMethod: scoringMethodShape,
  scoringTiers: PropTypes.arrayOf(scoringTierShape),
  artifactTypeName: PropTypes.string,
  displayMasteryDescription: PropTypes.bool,
  displayMasteryPercentText: PropTypes.bool,
  features: PropTypes.array,
  styles: stylesShape
}, _class2.defaultProps = {
  context: null,
  outcomeResult: null,
  scoringMethod: null,
  scoringTiers: null,
  artifactTypeName: null,
  displayMasteryDescription: false,
  displayMasteryPercentText: false,
  friendlyDescription: null,
  features: []
}, _class2)) || _class);
export { OutcomeView as default };